<template>
  <div 
    class="sm-breadcrumbs"
    v-show="!isMobile"
  >
    <div v-if="showHome" class="sm-breadcrumbs__item">
      <a 
        href="/" 
        class="sm-grey-link"
        @click.prevent="$router.push('/')"
      >Home</a>
    </div>
    <div 
      v-for="(item, index) in crumbs"
      :key="item.link"
      class="sm-breadcrumbs__item"
    >
      <span v-if="showHome || (!showHome && index > 0)" class="sm-breadcrumbs__item-delimiter"></span>
      <a 
        v-if="item.link != $route.path && !item.current"
        :href="item.link"
        class="sm-grey-link"
        @click.prevent="goTo(item.link)"
      >{{item.text}}</a>
      <span 
        v-else
        class="sm-breadcrumbs__item-text"
      >{{item.text}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'breadcrumbs-block',
  props: {
    crumbs: {
      type: Array,
      default: []
    },
    customPath: {
      type: Boolean,
      default: false
    },
    showHome: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  methods: {
    goTo(link) {
      if (!this.customPath)
        this.$router.push(link);
      else
        this.$emit('go', link);
    }
  }
}
</script>
